import { render, staticRenderFns } from "./simOpenTnBz.vue?vue&type=template&id=3e7a59bc&scoped=true&"
import script from "./simOpenTnBz.vue?vue&type=script&lang=js&"
export * from "./simOpenTnBz.vue?vue&type=script&lang=js&"
import style0 from "./simOpenTnBz.vue?vue&type=style&index=0&id=3e7a59bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a59bc",
  null
  
)

export default component.exports